// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"2bccef4d","450":"c28fdc00","549":"57298395"}[chunkId] + ".chunk.css";
};